export const PRICING_VERSION = Object.freeze({
  V1: 1,
  V2: 2,
  V3: 3,
});
